import {ChangeDetectionStrategy, Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-sms-code',
  templateUrl: './sms-code.component.html',
  styleUrls: ['./sms-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SmsCodeComponent {
  @Output()
  public enterCode: EventEmitter<string> = new EventEmitter();
  private codeLength = 4;

  public config = {
    length: this.codeLength,
    allowNumbersOnly: true,
    inputClass: 'sms-code__input',
    containerClass: 'sms-code__wrapper'
  };

  public onOtpChange(code) {
    if (this.codeLength !== code.length) {
      return;
    }
    this.enterCode.emit(code);
  }
}
